export class FetchingReflectionMapsError extends Error {
  constructor() {
    super(`Error while fetching reflection maps `);
    this.name = "FetchingReflectionMapsError";
  }
}
